var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"holder"},[_c('div',{staticClass:"exp",style:(_vm.expStyle)}),_c('div',{staticStyle:{"position":"absolute","height":"100%","width":"100%","top":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }